import {
	GET_USER_LIST_SUCCESS,
	GET_USER_LIST_FAIL,
	GET_USER_SUCCESS,
	GET_USER_FAIL,
	GET_USER_SEARCH_SUCCESS,
	GET_USER_SEARCH_FAIL,
} from "../actions/user/types";

const initialState = {
  employee: null,
  employees: null,
  filtered_employee: null,
  count: null,
  next: null,
  previous: null,
};

export default function employees(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_USER_LIST_SUCCESS:
      return {
        ...state,
        employees: payload.results.employees,
        count: payload.count,
        next: payload.next,
        previous: payload.previous,
      };
    case GET_USER_LIST_FAIL:
      return {
        ...state,
        employees: null,
        count: null,
        next: null,
        previous: null,
      };
		case GET_USER_SUCCESS:
			return {
				...state,
				employee: payload.employee,
			};
		case GET_USER_FAIL:
			return {
				...state,
				employee: null,
			};
		case GET_USER_SEARCH_SUCCESS:
			return {
				...state,
				filtered_employee: payload.filtered_employee,
			};
		case GET_USER_SEARCH_FAIL:
			return {
				...state,
				filtered_employee: null,
			};
		default:
			return state;
		}}